var _path, _path2, _path3, _rect, _circle, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 24C27.2188 24 20.8438 24 15 24C15 19.5817 18.8056 16 23.5 16C28.1944 16 32 19.5817 32 24Z",
    fill: "#EFB7A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25C11 21.9062 11 17.7812 11 14C14.3137 14 17 16.4624 17 19.5C17 22.5376 14.3137 25 11 25Z",
    fill: "#EFB7A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24.5H11L13.5 11",
    stroke: "#EFB7A4",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.80078,
    y: 4,
    width: 13,
    height: 11,
    rx: 5.5,
    fill: "#EFB7A4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 11.5,
    r: 2.5,
    fill: "#EFB7A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9689 25.7327C16.8078 26.1681 16.1922 26.1681 16.0311 25.7327L15.3644 23.931C15.3137 23.7942 15.2058 23.6863 15.069 23.6356L13.2673 22.9689C12.8319 22.8078 12.8319 22.1922 13.2673 22.0311L15.069 21.3644C15.2058 21.3137 15.3137 21.2058 15.3644 21.069L16.0311 19.2673C16.1922 18.8319 16.8078 18.8319 16.9689 19.2673L17.6356 21.069C17.6863 21.2058 17.7942 21.3137 17.931 21.3644L19.7327 22.0311C20.1681 22.1922 20.1681 22.8078 19.7327 22.9689L17.931 23.6356C17.7942 23.6863 17.6863 23.7942 17.6356 23.931L16.9689 25.7327Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9689 15.7308C24.8078 16.1661 24.1922 16.1661 24.0311 15.7308L22.8242 12.4693C22.7736 12.3324 22.6656 12.2245 22.5288 12.1738L19.2673 10.967C18.8319 10.8059 18.8319 10.1902 19.2673 10.0291L22.5288 8.82224C22.6656 8.7716 22.7736 8.6637 22.8242 8.52684L24.0311 5.2653C24.1922 4.82999 24.8078 4.82999 24.9689 5.2653L26.1758 8.52684C26.2264 8.6637 26.3344 8.7716 26.4712 8.82224L29.7327 10.0291C30.1681 10.1902 30.1681 10.8059 29.7327 10.967L26.4712 12.1739C26.3344 12.2245 26.2264 12.3324 26.1758 12.4693L24.9689 15.7308Z",
    fill: "#F18854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrong);
export default __webpack_public_path__ + "static/media/icon_strong.476817115635a2f31496d3b393bbc8f1.svg";
export { ForwardRef as ReactComponent };